class FluxStatisticsContacts {
  constructor(document) {
    document = document || {}
    this.new = document.new || 0
    this.existent = document.existent || 0
  }
}

module.exports = FluxStatisticsContacts
